import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-validate-shield_svg__a"
        d="M17.1 8.653l-1.4-1.455-5.4 5.614-1.9-2.08-1.4 1.56 3.3 3.43 6.8-7.069zM20 2H4c-1.1 0-2 .936-2 2.08v11.85c0 .728.4 1.456 1 1.768l8 4.99c.3.208.7.312 1 .312.4 0 .7-.104 1-.312l8-4.99c.6-.416 1-1.04 1-1.767V4.079C22 2.936 21.1 2 20 2zm0 13.93l-8 4.99-8-4.99V4.08h16v11.85z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-validate-shield_svg__a"
    />
  </svg>
);
